module.exports = __webpack_public_path__ + "static/media/scratch.75d4211f.gif";